export const allfilterArr = [
	[
		{
			label: '选择部门',
			type: 'select',
			attr: 'deptId',
			placeholder: '请选择',
			column: 8,
			labelWidth: '96px',
		},
		{
			label: '跟进人',
			type: 'select',
			attr: 'userId',
			placeholder: '请选择',
			column: 8,
			labelWidth: '96px',
		},
		{
			label: '跟进时间',
			type: 'dateRange',
			valueFormat:"YYYY-MM-DD",
			attr: 'followDate',
			placeholder: '请选择',
			column: 8,
			labelWidth: '96px',
		}
	],
	[
		{ type: 'button', column: 24, isBtnText: true }
	]
]
export const tableColumn = [
	{
		label: '客户名',
		prop: 'customerName',
		fixed: true,
        isCustomize: true,
        tableType: 'nameNoPointer',
		width: '200px'
	},
	{
		label: '客户编号',
		prop: 'customerId',
	},
	{
		label: '跟进内容',
		prop: 'message',
	},
	{
		label: '跟进人',
		prop: 'username',
	},
	{
		label: '跟进时间',
		prop: 'createTime',
		width: '200px',
	},
]
